module.exports = __webpack_public_path__ + "static/media/button-wizard-2.7bce255e.png";